import { Duration } from 'luxon';

import { WaterfallTenderExcludedRateQuote } from './WaterfallTenderExcludedRateQuote';
import { WaterfallTenderRateQuoteConfig } from './WaterfallTenderRateQuoteConfig';

export class WaterfallTenderConfig {
  rateShopId: number = -1;
  quotes: WaterfallTenderRateQuoteConfig[] = [];
  excludedQuotes: WaterfallTenderExcludedRateQuote[] = [];
  tenderTimeoutDuration?: Duration = Duration.fromISO('PT90M');

  constructor(opts?: Partial<WaterfallTenderConfig>) {
    if (opts?.rateShopId != null) {
      this.rateShopId = opts.rateShopId;
    }
    if (opts?.quotes != null) {
      this.quotes = opts.quotes.map(
        (val) => new WaterfallTenderRateQuoteConfig(val),
      );
    }
    if (opts?.excludedQuotes != null) {
      this.excludedQuotes = opts.excludedQuotes.map(
        (val) => new WaterfallTenderExcludedRateQuote(val),
      );
    }
    if (opts?.tenderTimeoutDuration != null) {
      if (typeof opts.tenderTimeoutDuration === 'string') {
        this.tenderTimeoutDuration = Duration.fromISO(
          opts.tenderTimeoutDuration,
        );
      } else {
        this.tenderTimeoutDuration = opts.tenderTimeoutDuration;
      }
    }
  }
}
